/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const loadingAboutMeConfig = {
  loading: {
    loadingProfile: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Retrieving ',
      titleBoldText: 'Policy detail...',
      description: 'This might take few seconds, Please wait !',
    },
    updateProfile: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Updating your',
      titleBoldText: 'organization profile...',
      description: 'This might take few seconds, Please wait !',
    },
  },
};
